import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[smlInputNumber]',
  standalone: true
})
export class InputNumberDirective implements OnInit {

  constructor(private readonly _el: ElementRef, private readonly renderer: Renderer2) { }
  
  ngOnInit() {
    // Hide spinner buttons
    const style = document.createElement('style');
    style.textContent = `
      input[smlInputNumber]::-webkit-outer-spin-button,
      input[smlInputNumber]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[smlInputNumber][type="number"] {
        -moz-appearance: textfield;
      }
    `;
    document.head.appendChild(style);
    
    // Prevent value change on scroll but allow page to scroll
    this._el.nativeElement.addEventListener('wheel', (e: WheelEvent) => {
      // Temporarily blur to prevent scroll from changing value, then refocus
      const currentValue = this._el.nativeElement.value;
      this._el.nativeElement.blur();
      setTimeout(() => {
        this._el.nativeElement.value = currentValue;
      }, 0);
    }, { passive: true });
  }
  
  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/\D+/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
